import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { EtablissementComponent } from './etablissement/etablissement.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { NewPasswordComponent } from './auth/new-password/new-password.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { AgencySignupComponent } from './agency/agency-signup/agency-signup.component';
import { onboardingGuard } from './guard/onboarding.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'new-password', component: NewPasswordComponent },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'register/:type',
    component: EtablissementComponent,
  },
  {
    path: 'agency/register',
    component: AgencySignupComponent,
    canActivate: [onboardingGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
